import { RESET_ALL_STATES, RESET_SUBMIT_STATE } from '../actions/actions';

import {
    SUBMIT_UPDATE_REQUEST,
    SUBMIT_UPDATE_SUCCESS,
    SUBMIT_UPDATE_FAILURE
  } from '../actions/actionTypes';
  

const initialState = {
  isLoading: false,
  error: null,
  data: null, 
};

const updateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_UPDATE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SUBMIT_UPDATE_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case SUBMIT_UPDATE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_SUBMIT_STATE:
        return initialState;
      default:
      return state;
  }
};

export default updateReducer;

  